// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip__jxExm","top":"top__X3wy+","bottom":"bottom__HFgfY"};